<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2024-03-05 15:53:50
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2024-03-08 16:31:26
 * @FilePath: /chaoyongtuan/src/views/shopManage/shopLibrary/addMaterial/components/local/local.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="local-content main-content-padding">
		<Panel :content-padding-top="16">
			<PanelHeader>
				<template slot="title">本地素材</template>
				<template slot="subTitle">供达人下载使用的原创素材</template>
			</PanelHeader>
			<el-tabs @tab-click="handleClick" v-model="tabName">
				<el-tab-pane v-for="item in tableArr" :label="item.label" :name="item.name" :key="item.name"></el-tab-pane>
			</el-tabs>
			<div class="mt-12 flex-row-align-center">
				<el-button type="primary" @click="btnClick">添加素材</el-button>
				<div class="color-gy-7 font-h6-regular ml-12">
					<span>已添加</span>
					<span class="color-gy-9 font-h6-medium ml-2 mr-2">
						{{ materialTotal }}
					</span>
					<span>条</span>
				</div>
			</div>
			<base-table
                :key="updateKey"
				v-loading="loading"
				class="mt-12"
				:ref="`multiTable`"
				:columns="columns"
				:page="pageInfo"
				:pageFixed="false"
				:list="tableData"
				:total="total"
			>
			</base-table>
            <yx-pagination
				style="padding-bottom: 0"
				:total="total"
				layout="total, prev, pager, next"
				:current-page="pageInfo.page_index"
				:page-size="pageInfo.page_size"
				@current-change="currentChange"
			/>
		</Panel>
		<AddMaterial ref="addMaterial" @addData="updateTableData" />
	</div>
</template>
<script>
import PanelHeader from '../panelHeader';
import AddMaterial from './addMaterialDrawer.vue';
import { cloneDeep } from 'lodash';
import getColumns from './columns.js';
export default {
	components: {
		PanelHeader,
		AddMaterial,
	},
    provide(){
        return {
			// 编辑标签
			injectUpdateTableData: row => this.updateTableData(row,'remove'),
			injectCancelTop: row => this.cancelTop(row),
			injectToTop: row => this.toTop(row),
		};
    },
	computed: {
        // 单个tab下添加素材的总数
		materialTotal() {
			const lengs = {
				1: this.videoTotalData.length,
				2: this.picTotalData.length,
			};
			return lengs[this.tabName];
		},
        // 单个tab下的当前页码数据列表
		tableData() {
			const datas = {
				1: this.videoTableData,
				2: this.picTableData,
			};
			return datas[this.tabName];
		},
		// 单个tab下的总数据列表
		totalData() {
			return {
				1: this.videoTotalData,
				2: this.picTotalData,
			};
		},
		columns() {
			return getColumns(this);
		},
	},
	props: {
		isBatch: {
			type: Boolean,
			default: false,
		},
		materialData: {
			type: Object,
			default: () => ({}),
		},
	},
	data() {
		return {
			videoTableData: [],
			videoTotalData: [],
			picTableData: [],
			picTotalData: [],
			tableArr: [
				{ label: '视频', name: '1' },
				{ label: '图片', name: '2' },
			],
			tabName: '1',
			loading: false,
			total: 0,
			pageInfo: {
				page_index: 1,
				page_size: 5,
			},
            updateKey: false,
		};
	},
	watch: {
		materialData({ material_details_video, material_details_pic }) {
			this.picTotalData = cloneDeep(material_details_pic.map(item => utils.filterUnderLine(item)));
			this.videoTotalData = cloneDeep(material_details_video.map(item => utils.filterUnderLine(item)));
			this.initData();
		},
	},
	methods: {
		// 显示添加本地素材抽屉
		btnClick() {
			this.$refs['addMaterial'].show(this.tabName, this.totalData[this.tabName]);
		},
		// 切换tab重新设置首页列表数据
		handleClick() {
			this.initData();
		},
		// 页码调整
		currentChange(val) {
			this.pageInfo.page_index = val;
			this.sliceTotalData();
		},
		// 更新总数据列表及首页列表数据
		// 注意两个tab的数据分别进行设置
		updateTableData(data, type) {
			const currentTotal = this.totalData[this.tabName];
			const operates = {
				add: () => {
					const firstNoTopIndex = this.getFirstNotTopIndex();
					if (this.tabName == 1) {
						this.videoTotalData.splice(firstNoTopIndex, 0, ...data.map(item => ({ ...item, isTop: 0 })));
					} else {
						this.picTotalData.splice(firstNoTopIndex, 0, ...data.map(item => ({ ...item, isTop: 0 })));
					}
				},
				remove: () => {
					if (this.tabName == 1) {
						this.videoTotalData = currentTotal.filter(item => item.id != data.id) || [];
					} else {
						this.picTotalData = currentTotal.filter(item => item.id != data.id) || [];
					}
				},
			};
			operates[type]?.();
			this.pageInfo.page_index = 1;
			this.total = this.totalData[this.tabName].length;
			this.sliceTotalData();
		},
		// 从总数据列表中切出当前页码的列表数据
		sliceTotalData() {
			const { page_index, page_size } = this.pageInfo;
			const startIndex = page_index === 1 ? 0 : (page_index - 1) * page_size;
			// 区分是视频还是图片
			if (this.tabName == 1) {
				this.videoTableData = this.totalData[this.tabName].slice(startIndex, page_size * page_index) || [];
			} else {
				this.picTableData = this.totalData[this.tabName].slice(startIndex, page_size * page_index) || [];
			}
		},
		// 提供给外部组件获取本组件的数据，用于传递参数
		getData() {
			const material_video_ids = [],
				material_pic_ids = [],
				material_video_infos = [],
				material_pic_infos = [];
			let hasSort = false;
			// 后端根据rank倒序排列，所以需要将总数据列表翻转
			this.videoTotalData.reverse().forEach((element, index) => {
				material_video_ids.push(element.id);
				material_video_infos.push({ material_id: element.id, rank: index + 1, is_top: element.isTop || 0 });
				// 判断是否有置顶的素材，如果有需要传递video_infos给外部组件
				if (element.isTop == 1) {
					hasSort = true;
				}
			});
			this.picTotalData.reverse().forEach((element, index) => {
				material_pic_ids.push(element.id);
				material_pic_infos.push({ material_id: element.id, rank: index + 1, is_top: element.isTop || 0 });
				// 判断是否有置顶的素材，如果有需要传递video_infos给外部组件
				if (element.isTop == 1) {
					hasSort = true;
				}
			});
			return {
				material_video_ids,
				material_pic_ids,
				material_infos: this.originListHasSort || hasSort ? [...material_video_infos, ...material_pic_infos] : [],
			};
		},
		// 初始化表格数据
		initData() {
			this.pageInfo.page_index = 1;
			this.total = this.totalData[this.tabName].length;
			this.sliceTotalData();
		},
		// 置顶
		// 找到目标元素，从总数据列表中删除目标元素
		// 将目标元素的isTop置为1，并将目标元素添加到总数据列表的首位
		toTop(row) {
			const index = this.totalData[this.tabName].findIndex(item => item.id === row.id);
			this.totalData[this.tabName].splice(index, 1);
			row.isTop = 1;
			this.totalData[this.tabName].unshift(row);
            this.updateKey = !this.updateKey;
			this.initData();
		},
		// 取消置顶
		// 找到目标元素，从总数据列表中删除目标元素
		// 将目标元素的isTop置为1，并将目标元素添加到第一个不是置顶元素的位置
		cancelTop(row) {
			const targetIndex = this.totalData[this.tabName].findIndex(item => item.id === row.id);
			this.totalData[this.tabName].splice(targetIndex, 1);
			const firstNoTopIndex = this.getFirstNotTopIndex();
			row.isTop = 0;
            this.updateKey = !this.updateKey;
			this.totalData[this.tabName].splice(firstNoTopIndex, 0, row);
			this.initData();
		},
		getFirstNotTopIndex() {
			let firstNoTopIndex = this.totalData[this.tabName].findIndex(item => item.isTop == 0);
			firstNoTopIndex = firstNoTopIndex === -1 ? this.totalData[this.tabName].length : firstNoTopIndex;
			return firstNoTopIndex;
		},
	},
};
</script>
<style lang="less" scoped></style>
